/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PhoneInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Prompt from 'DesignSystem/Questions/Prompt/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'



/** @type {import('Simple/types.js').View} */
export default function PhoneInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/PhoneInput",
  onChange
  
}) {
let questionIdValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'id',
format: fromHelpers.getPrompt,
})
let contactDetailsPhonedetailsPhonenumberValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneNumber',
})
let contactDetailsPhonedetailsPhonenumberChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneNumber',
})
let contactDetailsPhonedetailsIsvalidValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.isValid',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
 data="question.id"
 format="./helpers.js getPrompt"
 text={questionIdValueData}
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 width={250}
 marginTop={0}
 flexGrow={0}
 paddingLeft={0}
 paddingTop={dtSpaceXs}
 backgroundColor="transparent"
 required={true}
 data="contactDetails.phoneDetails.phoneNumber"
 onChange={contactDetailsPhonedetailsPhonenumberChangeData}
 value={contactDetailsPhonedetailsPhonenumberValueData}
 data="contactDetails.phoneDetails.isValid"
 invalid={!contactDetailsPhonedetailsIsvalidValueData}
 type="text"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXs}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
 placeholder="(000) 000-0000"
 autoFocus={true}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}